export default {
    taskList:'/task/comment/list',//备注列表
    addTask:'/task/comment',//新增备注
    getRemoveTask:'/task/comment/{id}',//删除备注
    logList:'/task/log/list',//日志
}